/**
 * Base API Configuration
 *
 * Shared RTK Query setup for all API slices
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Dev: direct to backend, Prod: /api (nginx proxies to backend)
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
console.log("API_BASE_URL",API_BASE_URL);
/**
 * Base API with shared configuration
 * All specific API slices will inject endpoints into this base API
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  tagTypes: ['MasterFlight', 'Codeshare', 'Airport', 'AircraftType'],
  endpoints: () => ({}), // Endpoints will be injected by specific API slices
});
